import { Flex } from './reflexbox';
Flex.displayName = 'Flex';
export default Flex;